import styled from 'styled-components';

import { Button, BUTTON_SIZES } from 'ui/button';
import { useFormContext } from '../../contexts/FormContext';
import { FormGridAreas } from '../../types';

const displayText = {
  button: 'Search users',
  loading: 'Loading...',
};

const StyledButton = styled(Button)`
  grid-area: ${FormGridAreas.submitButton};
  display: inline-flex;
  white-space: nowrap;
`;

export const SubmitButton = () => {
  const { canSubmit, isSubmitting } = useFormContext();
  return (
    <StyledButton
      data-test="user-lookup--submit-button"
      size={BUTTON_SIZES.LARGE}
      isDisabled={!canSubmit}
      type="submit"
    >
      {isSubmitting ? displayText.loading : displayText.button}
    </StyledButton>
  );
};
